module.exports = __webpack_public_path__ + "static/img/Galaxy_Watch_gear_S4.4d0eadc2.jpg";